import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { CourseFormValues } from 'src/models/Course.model';
import Course from '../Layouts/CourseForm';
import { useAddCourseMutation } from 'src/services/CourseService';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddCourseWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: CourseFormValues = {
    courseName: '',
  };

  // Validation Schema
  const validationSchema = object().shape({
    courseName: string().required('Please enter course name'),
  });

  const [addCourse] = useAddCourseMutation()

  // Handle Submit
  const handleSubmit = (
    values: CourseFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CourseFormValues>
  ) => {
    addCourse(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm()
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Course formikProps={formikProps} onClose={onClose}  formType='ADD'/>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddCourseWrapper;